<ion-grid *ngIf="paginationInfo() as info" class="ui-pagination">
  <ion-row class="ui-pagination__row">
    <ion-col class="ui-pagination__info" size="auto">
      Showing
      <strong>{{ info.totalItems === 0 ? 0 : info.rangeInPage.start }}</strong>
      –
      <strong>{{ info.totalItems < info.rangeInPage.end ? info.totalItems : info.rangeInPage.end }}</strong>
      of <strong>{{ info.totalItems }}</strong> {{ itemLabel }}
    </ion-col>

    <ion-col class="ui-pagination__options" size="auto">
      <ion-list lines="none">
        <ion-item>
          <ion-select
            [value]="currentPageSize()"
            interface="popover"
            (ionChange)="onPageSizeChange($any($event).detail.value)"
          >
            <ion-select-option *ngFor="let size of itemsPerPageList" [value]="size"
              >{{ size }} / page</ion-select-option
            >
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
    <ion-col *ngIf="sortingInfo.length" class="ui-pagination__options" size="auto">
      <ion-list lines="none">
        <ion-item>
          <ion-select
            [value]="selectedSortingOption"
            [compareWith]="compareSortOptions"
            [selectedText]="selectedSortingOption?.displayName || 'Sort by'"
            interface="popover"
            (ionChange)="onSortingOptionChange($event)"
          >
            <ion-select-option *ngFor="let item of sortingInfo" [value]="item">{{
              item.displayName
            }}</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
      <ion-button
        *ngIf="selectedSortingOption"
        fill="clear"
        color="danger"
        class="ui-pagination__sort-clear"
        (click)="onSortingRemove()"
      >
        <ion-icon class="ui-pagination__sort-clear-img" slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-col>

    <ion-col class="ui-pagination__controls ion-justify-content-end">
      <ion-button
        fill="clear"
        class="ui-pagination__nav"
        [disabled]="currentPage() === 1"
        (click)="goTo(currentPage() - 1)"
      >
        <ion-icon slot="start" name="chevron-back-outline"></ion-icon>
        Prev
      </ion-button>

      <ion-button
        *ngFor="let page of visiblePages()"
        fill="clear"
        class="ui-pagination__page"
        [class.ui-pagination__page--active]="page === currentPage()"
        (click)="goTo(page)"
      >
        {{ page }}
      </ion-button>

      <ion-button
        fill="clear"
        class="ui-pagination__nav"
        [disabled]="currentPage() === info.totalPageCount"
        (click)="goTo(currentPage() + 1)"
      >
        Next
        <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>
</ion-grid>
